/**
 * log模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const log = {
  //分页
  pageLog(params) {
    return $http.post(`${global.API_URL}/sme/log/page`,params);
  },
  //折线图
  dataProcessing(params) {
    return $http.post(`${global.API_URL}/sme/log/dataProcessing`,params);
  },
  //详情
  queryLogDetails(params) {
    return $http.post(`${global.API_URL}/sme/log/queryLogDetails`,params);
  }
}

export default log;



// WEBPACK FOOTER //
// ./src/api/log.js